import { PATCH_USER_EXTENSION_REQUEST } from 'actions'
import { PatchUserExtensionRequestAction } from './types/PatchUserExtensionRequestAction'
import { PatchUserExtensionRequestActionValues } from './types/PatchUserExtensionRequestActionValues'

interface Props {
  requestValues: PatchUserExtensionRequestActionValues,
}

export const createPatchUserExtensionRequestAction = ({ requestValues }: Props): PatchUserExtensionRequestAction => {
  return {
    type: PATCH_USER_EXTENSION_REQUEST,
    requestValues,
  }
}
